import React from 'react';
import { useAppContext } from './app-context';
import styles from './app.module.css';

const BackArrow = () => {
    const { setIsSidenavOpen } = useAppContext();
    
    if (!setIsSidenavOpen) {
        return null;
    }
    
    return (
        <button
            className={styles.backArrow}
            onClick={() => setIsSidenavOpen(true)}
        >
            <span className="material-icons">arrow_back</span>
        </button>
    );
};

export default BackArrow;
